import { z } from 'zod'

export const schema = z.object({
  rentUnitStructure: z.enum([
    'SINGLE_UNIT',
    'MULTIPLE_INDEPENDENT',
    'MULTIPLE_DEPENDENT',
    'NO_RENT_UNIT_STRUCTURE_FOUND',
  ]),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  cottageId: z.string().min(1),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
